export default __webpack_public_path__ + "static/media/img-o-n-3-chat-support.1be3e2f5.png";